import Header from "../../../../Components/Header";
import PurchaseForm from "./PurchaseForm";

const CreatePurchaseReturnBulk = () => {
  return (
    <div className="d-flex flex-column" style={{height:'100vh'}}>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
        <PurchaseForm />
      </div>
    </div>
  );
};

export default CreatePurchaseReturnBulk;
